/**
 * Ranked horizontal-bar breakdown for one choice question — used
 * identically for single- and multi-select (a multi-select question's
 * percentages naturally sum to more than 100%, which is expected).
 * Options are sorted by count descending, not by their config order.
 */
export default function QuizAnswerBars({ question, counts, total }) {
  const ranked = [...question.options]
    .map((opt) => ({ ...opt, count: counts?.[opt.value] ?? 0 }))
    .sort((a, b) => b.count - a.count)

  return (
    <div className="bg-white rounded-3xl shadow-card p-6">
      <h3 className="text-sm font-bold text-ink-1">{question.question}</h3>
      {total === 0 ? (
        <p className="mt-4 text-xs text-ink-3">No responses yet.</p>
      ) : (
        <div className="mt-4 space-y-3">
          {ranked.map((opt) => {
            const pct = Math.round((opt.count / total) * 100)
            return (
              <div key={opt.value} className="space-y-1">
                <div className="flex items-center gap-2">
                  <p className="text-xs font-medium text-ink-2 flex-1">{opt.label}</p>
                  <span className="text-xs font-bold text-ink-3">{opt.count} · {pct}%</span>
                </div>
                <div className="h-1.5 bg-canvas rounded-full overflow-hidden">
                  <div className="h-full rounded-full bg-accent" style={{ width: `${pct}%` }} />
                </div>
              </div>
            )
          })}
        </div>
      )}
    </div>
  )
}
